import React from "react";
import { withRouter } from 'react-router-dom';
import withCurrentUser from '../../../hocs/with_current_user.js.jsx';
import withShowToast from '../../../hocs/with_show_toast.js';
import { compose } from 'redux';
import I18n from "../../../base/i18n.js.jsx";
import { withStyles } from '@material-ui/styles';

import Container from "../../../base/components/container.js.jsx";
import InvestmentsList from "../../../base/user_investments/investments_list.js";

import NavBlock from "./components/nav_block.js";
import Title from "./components/title.js";
import InvestmentsStatsBlock from "./components/investments_stats_block.js";
import NoProjectsBlock from "./components/no_projects_block.js";
import IdentificationInfoBlock from "./components/identification_info_block.js";
import LoadingIndicator from "./components/loading_indicator.js";

import LoadInvestmentsListUseCase from "../../../use_cases/projects/investments/load_investments_list_use_case.js";

import IcLogOut from "./resources/icons/ic_log_out.js";

import Routes from "../../routes.js";

const styles = theme => ({
  container: {
    ['@media (max-width: 768px)']: {
      paddingLeft: "24px",
      paddingRight: "24px"
    },
  },
  root: {
    padding: "50px 0",
    background: "white",
    ['@media (max-width: 768px)']: {
      padding: "24px 0 32px"
    }
  },
  identificationBlock: {
    marginBottom: "60px",
    ['@media (max-width: 768px)']: {
      marginBottom: "24px"
    },
  },
  chevronIcon: {
    display: "none",
    marginLeft: "9px",
    ['@media (max-width: 768px)']: {
      display: "block"
    }
  },
  header: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginBottom: "75px",
    ['@media (max-width: 768px)']: {
      flexDirection: "column",
      marginBottom: "30px",
      alignItems: "flex-start",
    }
  },
  logOut: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    fontSize: "16px",
    outline: "none",
    padding: "0",
    textTransform: "uppercase",
    "&:hover": {
      textDecoration: "underline"
    },
    ['@media (max-width: 768px)']: {
      fontSize: "13px"
    }
  },
  logOutIcon: {
    height: "25px",
    width: "25px",
    marginRight: "11px",
    padding: "0"
  },
  titleLink: {
    color: theme.palette.grayText,
    fontSize: "20px",
    display: "flex",
    alignItems: "flex-start",
    lineHeight: "1",
    margin: "0",
    textDecoration: "none",
    textTransform: "uppercase",
    "&:hover": {
      textDecoration: "underline"
    },
    ['@media (max-width: 768px)']: {
      fontSize: "13px",
    }
  }
});

class ProfileIndexPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      investments: [],
      loading: true
    }
  }

  componentDidMount() {
    LoadInvestmentsListUseCase.execute()
    .then(result => {
      this.setState({
        loading: false,
        investments: result.data.investments
      })
    })
    .catch((result) => {
      this.setState({
        loading: false
      });
      this.props.showServerErrorIfNeed(result);
    });
  }

  onClickLogOut = () => {
    const { signOut, history } = this.props;
    if(signOut) {
      signOut(() => {
        history.push(Routes.xavin())
      })
    }
  }

  render() {
    const { classes, userOnceLoaded, adminDashboardAbilityInfo: { use: allowAdmin = false } = {} } = this.props
    const { loading, investments } = this.state
    if(!userOnceLoaded || allowAdmin) {
      return <React.Fragment />
    }

    return <div className = { classes.root }>
      <Container className = { classes.container }>
        <IdentificationInfoBlock className = { classes.identificationBlock } />
        <Title/>
        <NavBlock/>
        { loading && <LoadingIndicator /> }
        { !loading && (investments.length > 0 ?
          (<React.Fragment>
            <InvestmentsStatsBlock />
            <InvestmentsList investments = { investments } />
          </React.Fragment>) : (
            <NoProjectsBlock/>
          )) }
        <div className = { classes.footer }>
          <button className = { classes.logOut }
                  onClick = { this.onClickLogOut } >
            <IcLogOut className = { classes.logOutIcon } />
            { I18n.t("shared.log_out") }
          </button>
        </div>
      </Container>
    </div>
  }
}

export default compose(withShowToast, withCurrentUser, withRouter, withStyles(styles))(ProfileIndexPage);
